import axios from 'axios';
import ServerProperties from '../../config/server.js'

export function ModelReadUserHaveAsset(params){
	axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
	axios.get(ServerProperties.ATM_CLOUD.API+'User/?page='+ params.page+'&'+params.order+'&'+params.filter)
	.then(function (response) {
		params.onsuccess(params, response);
	})
	.catch(function (error) {
		try{
			params.onfailed(params, error.response)
		}catch(err){
			console.log(error)
		}
	});
}
export function ModelReadUserAsset(params){
	// console.log(params)
	let urlRequest = "";
	axios.defaults.headers.common['Authorization'] = "Bearer "+params.data.AuthorizationToken;
	if (params.action === 'read') {
    	urlRequest = ServerProperties.ATM_CLOUD.API+'Asset/User/'+params.selectedData.Alias+'/'
    }else{
    	urlRequest = params.NextUrl
    }
	axios.get(urlRequest)
	.then(function (response) {
		params.onsuccess(params, response);
	})
	.catch(function (error) {
		try{
			params.onfailed(params, error.response)
		}catch(err){
			console.log(error)
		}
	});
}	


// WEBPACK FOOTER //
// ./src/App/user/userHaveAsset/model.js